<template>
  <!-- 本组件为：横向分段图，如周报表格里的横向分段图 -->
  <div :class="className" :style="{height:height,width:width}" />
  <!-- <p>chartDate--{{ chartDate }}</p> -->
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour, usedTime, howLongAgo, getDateAndWeek } from '@/utils/updateTime.js'
import i18n from '@/i18n'
// var data = []
var dataCount = 100// 测试数据条数
var startTime = 1607428042519 // 2018/5/9 11:16:31
// var categories = ['Key switch', 'Hour counter'].reverse()
var categories = [i18n.t('allDeviceDetail.KeySwitch'), i18n.t('yhubReport.HourCounter')].reverse()


function renderItem(params, api) {
  var categoryIndex = api.value(0)
  var start = api.coord([api.value(1), categoryIndex])
  var end = api.coord([api.value(2), categoryIndex])
  var height = api.size([0, 1])[1] * 0.6

  return {
    type: 'rect',
    shape: echarts.graphic.clipRectByRect({
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0],
      height: height
    }, {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height
    }),
    style: api.style()
  }
}

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    chartDate: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      legendData: []
    }
  },
  watch: {
    chartDate: {
      handler(newValue, oldValue) {
        this.chartDate = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 50)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // categories = ['Key switch', 'Hour counter'].reverse()
      categories = [i18n.t('allDeviceDetail.KeySwitch'), i18n.t('yhubReport.HourCounter')].reverse()
      var data = [// value 第一个参数: 设备 index;第二个参数: 状态的开始时间;第三个参数: 状态的结束时间;第四个参数: 状态的持续时间;
        // { name: '运行', value: [0, 1604835791000, 1604835791000 + 600000, 600000], itemStyle: { normal: { color: 'green' }}},
        // { name: '停机', value: [0, 1604836391000, 1604836391000 + 600000, 600000], itemStyle: { normal: { color: 'red' }}},
        // { name: '运行', value: [0, 1604836991000, 1604836991000 + 600000, 600000], itemStyle: { normal: { color: 'green' }}},
        // { name: '停机', value: [0, 1604837591000, 1604837591000 + 600000, 600000], itemStyle: { normal: { color: 'red' }}},
        // { name: '运行', value: [1, 1604835791000, 1604835791000 + 600000, 600000], itemStyle: { normal: { color: 'green' }}},
        // { name: '运行', value: [1, 1604836391000, 1604836391000 + 600000, 600000], itemStyle: { normal: { color: 'green' }}},
        // { name: '停机', value: [1, 1604836991000, 1604836991000 + 600000, 600000], itemStyle: { normal: { color: 'red' }}},
        // { name: '运行', value: [1, 1604837591000, 1604837591000 + 600000, 600000], itemStyle: { normal: { color: 'green' }}}

      ]
      var times = []
      this.chartDate.forEach(v => {
        data.push(v)
        times.push(v.value[1])
      })
      times.sort()
      // console.log('*****chartDate******', this.chartDate)

      if (this.chart) {
        this.chart.clear()
      }
      this.chart = echarts.init(this.$el)
      var myOption = {
        tooltip: {
          formatter: function(params) {
            return params.marker + params.name + ': ' + Math.round(params.value[3] / 1000) + ' s'
          }
        },
        title: {
          // text: '设备状态',
          // left: 'center'
        },
        // legend: {
        //   data: types,
        //   bottom: 30,
        //   right: 20,
        //   selectedMode: false
        // },
        dataZoom: [{
          type: 'slider',
          filterMode: 'weakFilter',
          showDataShadow: false,
          top: 180,
          height: 10,
          // start: 0,
          // end: 100,
          borderColor: 'transparent',
          backgroundColor: '#e2e2e2',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z', // jshint ignore:line
          handleSize: 20,
          handleStyle: {
            shadowBlur: 6,
            shadowOffsetX: 1,
            shadowOffsetY: 2,
            shadowColor: '#aaa'
          },
          labelFormatter: ''
        }, {
          type: 'inside',
          filterMode: 'weakFilter'
        }],
        grid: {
          height: 130,
          top: 10
        },
        xAxis: {
          type: 'time',
          min: times[0],
          scale: true
          // axisLabel: {
          //   formatter: function(val) {
          //     console.log('val--', val)
          //   }
          // }
        },
        yAxis: {
          data: categories
        },
        series: [
          {
            type: 'custom',
            renderItem: renderItem,
            itemStyle: {
              normal: {
                opacity: 0.8
              }
            },
            encode: {
              x: [1, 2, 3],
              y: 0
            },
            data: data
          }]
      }
      this.chart.setOption(myOption, true)
    }
  }
}
</script>
